import PropTypes from 'prop-types';
import { useCallback, useContext } from 'react';
import styled from 'foundations-theming/utils';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SimpleBotIcon } from 'foundations-assets';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { BOT, SYSTEM } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { mrHubBot } from 'conversations-message-history/constants/images';
import { getNonDefaultSource, getSenderType, getDisplayName } from 'conversations-message-history/senders/operators/getters';
import MessageHistoryContext from '../MessageHistoryContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIAVATAR_SIZE = 32;
const SenderAvatarWrapper = styled.div.withConfig({
  displayName: "SenderAvatar__SenderAvatarWrapper",
  componentId: "sc-1ulmad9-0"
})(["position:relative;"]);
const StatusDotWrapper = styled.div.withConfig({
  displayName: "SenderAvatar__StatusDotWrapper",
  componentId: "sc-1ulmad9-1"
})(({
  theme
}) => {
  return {
    position: 'absolute',
    display: 'flex',
    bottom: '2px',
    right: '-3px',
    border: `2px solid ${theme.color['fill-surface-raised']}`,
    height: '14px!important',
    width: '14px!important',
    'margin-right': 0,
    'border-radius': '50%'
  };
});
function SenderAvatar({
  isLoading,
  onClick,
  present,
  sender,
  size = 'sm'
}) {
  const {
    AvatarComponent
  } = useContext(MessageHistoryContext);
  const hasClickHandler = useCallback(() => {
    return Boolean(onClick);
  }, [onClick]);
  const handleClick = useCallback(() => {
    if (onClick) onClick(sender);
  }, [onClick, sender]);
  const StyledAvatarComponent = styled(AvatarComponent)(({
    theme
  }) => {
    return {
      background: `${theme.color['fill-primary-disabled']}`,
      'border-radius': '50%',
      svg: {
        'background-size': `${theme.space['500']}`,
        'background-repeat': 'no-repeat'
      }
    };
  });
  const renderAvatar = useCallback(() => {
    if (isLoading) {
      return /*#__PURE__*/_jsx(SkeletonCircle, {
        "data-test-id": "skeleton-circle-avatar",
        size: UIAVATAR_SIZE,
        use: "on-shade"
      });
    }
    if (!sender) {
      return /*#__PURE__*/_jsx("span", {
        "data-test-id": "unknown-avatar-wrapper",
        children: /*#__PURE__*/_jsx(AvatarComponent, {
          "data-test-id": "unknown-avatar-wrapper",
          childMarginInlineStart: "300",
          childTruncateLength: 200,
          showTooltip: !hasClickHandler(),
          size: size || 'sm',
          type: "contact"
        })
      });
    }
    const senderType = getSenderType(sender);
    if (senderType === BOT) {
      return /*#__PURE__*/_jsx("span", {
        "data-test-id": "bot-avatar-wrapper",
        children: /*#__PURE__*/_jsx(StyledAvatarComponent, {
          childMarginInlineStart: "300",
          childTruncateLength: 200,
          showTooltip: !hasClickHandler(),
          size: size || 'sm',
          src: mrHubBot || undefined
        })
      });
    }
    if (senderType === SYSTEM) {
      return /*#__PURE__*/_jsx(IconHolder, {
        icon: SimpleBotIcon,
        size: "600",
        color: 'icon-core-subtle',
        backgroundColor: 'fill-primary-disabled',
        borderWidth: "0",
        padding: "100",
        borderRadius: "full",
        "data-test-id": "system-sender-avatar"
      });
    }
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": "sender-avatar-wrapper",
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(AvatarComponent, {
        childMarginInlineStart: "300",
        childTruncateLength: 200,
        showTooltip: false,
        size: size || 'sm',
        type: "contact",
        src: getNonDefaultSource(sender) || undefined,
        displayName: getDisplayName(sender) || undefined
      })
    });
  }, [isLoading, sender, size, AvatarComponent, hasClickHandler, handleClick, StyledAvatarComponent]);
  return /*#__PURE__*/_jsxs(SenderAvatarWrapper, {
    onClick: handleClick,
    children: [renderAvatar(), present &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StatusDotWrapper, {
      children: /*#__PURE__*/_jsx(StatusDot, {
        "data-test-id": "status-dot",
        use: "oz"
      })
    })]
  });
}
SenderAvatar.displayName = 'SenderAvatar';
SenderAvatar.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  present: PropTypes.bool,
  sender: RecordPropType('Sender'),
  size: PropTypes.string
};
export default SenderAvatar;